// extracted by mini-css-extract-plugin
module.exports = {"wisetack_button":"Button_wisetack_button__N_UvG"};